// mv swiper
jQuery(function () {
  var swiper = new Swiper('.swiper-mv', {
    slidesPerView: 1.4, // 1表示
    spaceBetween: 10, // 間隔10
    loop: true, // 最後のスライドが終わったら最初のスライドが開始
    centeredSlides: true, // 現在のスライドを中央に配置
    autoplay: {
      delay: 5000, // 5000ミリ秒で自動でスライドが動く
      disableOnInteraction: 'true', // ユーザーが操作したら自動再生が止まる
    },
    pagination: { // 丸のページネーション
      el: ".swiper-pagination",
      clickable: true  //ページネーションのクリック有効に
    },
  });
});

// フェード
function fadeAnime(){

//動きの指定
jQuery('.fadeUpTrigger').each(function(){ 
  var elemPos = jQuery(this).offset().top+50;
  var scroll = jQuery(window).scrollTop();
  var windowHeight = jQuery(window).height();
  if (scroll >= elemPos - windowHeight){
  jQuery(this).addClass('fadeUp');
  }else{
  jQuery(this).removeClass('fadeUp');
  }
});
}

// 画面をスクロールをしたら動く
jQuery(window).scroll(function (){

  fadeAnime();

});

// 画面が読み込まれたらすぐに動く
jQuery(window).on('load', function(){

  fadeAnime();

});



jQuery(window).resize(function(){
  var $window = jQuery(this).width();
  var bp = 1024;
  if($window > bp){
    jQuery('.drawer-bars,.drawer-nav').removeClass('is-checked');
  };
});

/* ハンバーガーメニュー */
jQuery(function() {
  jQuery('.drawer-bars').on('click', function(){
    jQuery(this).toggleClass('is-checked');
    if(jQuery(this).hasClass('is-checked')){
      jQuery('.drawer-nav').addClass('is-checked');
      jQuery('body').addClass('is-checked');
    } else {
      jQuery('.drawer-nav').removeClass('is-checked');
      jQuery('.drawer-bars').removeClass('is-checked');
      jQuery('body').removeClass('is-checked');
    }
  });
});

jQuery(function() {
  jQuery('.drawer-nav a[href]').on('click', function() {
    jQuery('.drawer-bars,.drawer-nav').trigger('click');
  });
});